import { gql } from 'apollo-boost';
import moment from 'moment';
const query = gql`
  query carrierBatchById($carrierBatchId: ID!) {
    remittanceBatch {
      carrierBatchById(carrierBatchId: $carrierBatchId) {
        createdUtc
        id
        carrierName
        totalAmountDue
        invoiceCount
        remittanceBatchId
        scac
        carrierItems {
          invoiceId
          invoiceNumber
          shipmentId
          proNumber
          glCode
          amountDue
          dueDate
        }
      }
    }
  }
`;

export const retrieveData = async (carrierBatchId, ApolloClient) => {
  const {
    data: {
      remittanceBatch: { carrierBatchById }
    }
  } = await ApolloClient.query({
    query,
    variables: {
      carrierBatchId
    }
  });
  carrierBatchById.createdLocal = moment
    .utc(carrierBatchById.createdUtc)
    .local();
  return carrierBatchById;
};
